export default __webpack_public_path__ + "static/media/mauquenchy8.38039d7f.jpg";